<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_13"></a><a id="chapter01"></a>Gasoline Prices<br/>Expected to Climb Higher</h2>
<p class="para">W<span class="smallcaps">ASHINGTON</span>—There’s pump shock at every corner gas station, with prices well over $7 a gallon—and the government says you’d better get used to it.</p>
<p class="indent-para">The Energy Department projects high gasoline prices at least through next year as producers struggle to keep up with demand, which has not slackened appreciably despite rising prices.</p>
<p class="indent-para">Crude oil prices climbed to an all-time high of $112 per barrel yesterday, triggering a 634-point drop in the Dow-Jones Industrial average on the New York Stock Exchange.</p>
<p class="indent-para">“We can expect to see gasoline prices soar as high as nine or ten dollars a gallon this summer,” said James Dykes, chairman of the Federal Reserve Board. “Gas prices have nowhere to go but up.”</p>
<p class="indent-para">Energy Department officials blamed the climbing oil prices on the growing demand for petroleum by China and India, two of the fastest-growing economies in the world, coupled with the fact that global oil production has peaked and is unlikely to increase.</p>
<p class="indent-para">“There hasn’t been a major new oil field discovered in well over a decade,” said Roberta Groves, head of Gould Energy Corporation’s explorations division. “With global oil production flat and global demand increasing steadily, oil prices will continue to climb for the foreseeable future.”</p>
<p class="right-para">—<em>F<span class="smallcaps">INANCIAL</span> N<span class="smallcaps">EWS</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?6e7f84de